module.exports = __webpack_public_path__ + "static/media/2C.1d23659b.svg";